import axios from 'axios';
import BaseApi from './api.base'
class Api extends BaseApi {
	suppliers = null;
	apiBase = 'api/energy/';
	lastComparisonPostData = null;
	metaData = null;
	resultsCache = [];
	super() {}
	
	async getResults(data) {
		this.lastComparisonPostData = data;
		let results = await this.postUrl('comparison', data);
		return results;
	}
	async getPackageDetails(id, fromComparison = false) {
		let results;
		if (fromComparison && this.lastComparisonPostData) {
			results = await this.postUrl(
				`package/${id}`,
				this.lastComparisonPostData
			);
			return results.Packages[0];
		} else {
			results = await this.getUrl(`package/${id}`);
			return results.data.Packages[0];
		}
	}
	async getPackageDetailsInContext(id) {
		if (this.lastComparisonPostData) {
			let results = await this.postUrl(
				`package/${id}`,
				this.lastComparisonPostData
			);
			return results.Packages[0];
		} else {
			return this.getPackageDetails(id);
		}
	}
	async getCarTop(urlParameters) {
		let url = `https://www.poliswijzer.nl/api/wlb/auto/veh/top5?${urlParameters}`;
		//let url = `http://poliswijzer.local/api/wlb/auto/veh/top5?${urlParameters}`;
		return this.getUrl(url);
	}
	async postUrl(url, postData) {
		// eslint-disable-next-line
		let completeUrl = APP_APILOCATION + this.apiBase + url;
		let lsVal = localStorage.getItem("useTest");
		if (lsVal == "1") {
			// eslint-disable-next-line
			completeUrl = APP_APITESTLOCATION + this.apiBase + url;			
		}
		let refCode = this.getRefCode();
		postData.refCode = refCode;
		let cacheKey = this.getCacheKey(completeUrl, postData);
		let data = await axios({
			method: 'post',
			url: completeUrl,
			data: postData,
			// eslint-disable-next-line
			headers: { apiKey: `${APP_APIKEY}` }
		});
		
		let results = data.data.items ? data.data.items[0] : data.data;
		this.resultsCache[cacheKey] = results;
		return results;		
	}
	getCacheKey(url, postData = {}) {
		postData = Object.assign({}, postData);
		let stringified = JSON.stringify({ ...postData, url });
		let cacheKey = btoa(stringified);
		return cacheKey;
	}
	getRefCode() {
		// eslint-disable-next-line
		return parseInt(APP_REFCODE);
	}
	async getUrl(url) {
		// eslint-disable-next-line
		let completeUrl = APP_APILOCATION + this.apiBase + url;
		let lsVal = localStorage.getItem("useTest");
		if (lsVal == "1") {
			// eslint-disable-next-line
			completeUrl = APP_APITESTLOCATION + this.apiBase + url;			
		}
		if (url.indexOf("http") > -1) {
			completeUrl = url;
		}
		let refCode = this.getRefCode();

		completeUrl = `${completeUrl}${
			completeUrl.indexOf('?') > -1 ? '&' : '?'
			}refCode=${refCode}`;
		// eslint-disable-next-line
		let headers  = completeUrl.indexOf("poliswijzer") ? null : { apiKey: `${APP_APIKEY}` }
		let data = await axios({
			method: 'get',
			url: completeUrl,
			headers: headers
		});
		if (data.data && data.data.items) {
			return data.data.items[0];
		} else {
			return data;
		}
	}
	async getBaseForm(serialId, params) {
		//let refCode = this.getRefCode();
		// eslint-disable-next-line
		let url = `${APP_FORMAPILOCATION}api/form/${serialId}?showDependentQuestions=true&${params}&apiKey=${APP_APIKEY}`;
		let lsVal = localStorage.getItem("useTest");
		if (lsVal == "1") {
			// eslint-disable-next-line
			url = `${APP_FORMTESTAPILOCATION}api/form/${serialId}?showDependentQuestions=true&${params}&apiKey=${APP_APIKEY}`;
		}
		
		let data = await axios({
			method: 'post',
			url: url,
			data: {
				formBindingModel: {}
			}
		});

		return data.data;
	}
	async saveForm(formData, serialId, params = '') {
		// eslint-disable-next-line
		let completeUrl = `${APP_FORMAPILOCATION}api/form/${serialId}?apiKey=${APP_APIKEY}&${params}`;
		let lsVal = localStorage.getItem("useTest");
		if (lsVal == "1") {
			// eslint-disable-next-line
			completeUrl = `${APP_FORMTESTAPILOCATION}api/form/${serialId}?apiKey=${APP_APIKEY}&${params}`;
		}
		try {
			let response = await axios({
				method: 'post',
				url: completeUrl,
				data: formData
			});
			return response.data;
		} catch (e) {
			return e;
		}
	}
	async getMetaData() {
		// eslint-disable-next-line
		if (this.metaData) {
			return this.metaData;
		} else {
			let results = await this.getUrl(`siteinfo/metadata`);
			return results.data;
		}
	}
	saveMetaData(metaData) {
		this.metaData = metaData;
	}
	async getTop(durable = true, rows = 5) {
		let results = await this.getUrl(`comparison/top/${rows}/${durable}`);

		return results.Results;
	}
}
let api = new Api();
export default api;
